/* __next_internal_client_entry_do_not_use__ Toaster auto */ import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Toast, ToastClose, ToastDescription, ToastProvider, ToastTitle, ToastViewport } from './Toast';
import { useToast } from './useToast';
export function Toaster() {
    const { toasts } = useToast();
    return /*#__PURE__*/ _jsxs(ToastProvider, {
        children: [
            toasts.map((param)=>{
                let { id, title, description, action, ...props } = param;
                return /*#__PURE__*/ _jsxs(Toast, {
                    ...props,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "grid gap-1",
                            children: [
                                title && /*#__PURE__*/ _jsx(ToastTitle, {
                                    className: "font-bold text-sm",
                                    children: title
                                }),
                                description && /*#__PURE__*/ _jsx(ToastDescription, {
                                    className: "text-xs",
                                    children: description
                                })
                            ]
                        }),
                        action,
                        /*#__PURE__*/ _jsx(ToastClose, {})
                    ]
                }, id);
            }),
            /*#__PURE__*/ _jsx(ToastViewport, {})
        ]
    });
}
